<template>
    <el-form ref="form" :model="sysModel" :rules="rules" label-width="150px">
        <el-form-item label="學年" prop="schoolYear">
            <el-input v-model="sysModel.schoolYear" placeholder="請輸入學年"></el-input>
        </el-form-item>
        <el-form-item label="學期" prop="semester">
            <el-select v-model="sysModel.semester" placeholder="請選擇學年">
                <el-option v-for="smt in semesters" :key="smt.value" :label="smt.text" :value="smt.value"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="郵件寄送者" prop="mailDisplay">
            <el-input v-model="sysModel.mailDisplay" placeholder="請輸入郵件寄送者"></el-input>
        </el-form-item>
        <el-form-item label="郵件信箱" prop="mailFrom">
            <el-input v-model="sysModel.mailFrom" placeholder="請輸入郵件信箱"></el-input>
        </el-form-item>
        <el-form-item label="借用開放日期(起)" prop="dateBegin">
            <el-date-picker
                    v-model="sysModel.dateBegin"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{firstDayOfWeek:1}"
            ></el-date-picker>
        </el-form-item>
        <el-form-item label="借用開放日期(訖)" prop="dateEnd">
            <el-date-picker
                    v-model="sysModel.dateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{firstDayOfWeek:1}"
            ></el-date-picker>
        </el-form-item>
        <el-form-item label="信件簽名">
            <vue-editor
                    v-model="sysModel.footer" style="font-size: initial;line-height: initial;"
                    :editorToolbar="customToolbar"
            ></vue-editor>
        </el-form-item>
        <el-button @click="submit">
            變更
        </el-button>
    </el-form>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';
    import {Semesters} from '../../constants';
    import {VueEditor} from 'vue2-editor';

    const {mapState, mapActions} = createNamespacedHelpers('setting');
    export default {
        name: 'SysForm',
        components:{
            VueEditor
        },
        data: () => ({
            sysModel: {
                mailDisplay: '',
                mailFrom: '',
                schoolYear: '',
                semester: 0,
                dateBegin:'',
                dateEnd:'',
                footer: '',
            },
            rules: {
                schoolYear: [
                    {required: true, message: '請輸入學年!', trigger: 'blur'}
                ],
                semester: [
                    {required: true, message: '請選擇學期!'}
                ],
                mailDisplay: [
                    {required: true, message: '請輸入郵件寄送者!', trigger: 'blur'}
                ],
                mailFrom: [
                    {required: true, message: '請輸入郵件信箱!', trigger: 'blur'}
                ],
                dateBegin: [
                    {required: true, message: '請輸入借用開始日期!', trigger: 'blur'}
                ],
                dateEnd: [
                    {required: true, message: '請輸入借用結束日期!', trigger: 'blur'}
                ]
            },
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                ["clean"] // remove formatting button
            ]
        }),
        computed: {
            semesters() {
                return Semesters;
            },
            ...mapState(['sys']),
        },
        methods: {
            ...mapActions({
                saveSetting: 'saveSysAction'
            }),
            async submit() {
                const {form} = this.$refs;
                form.validate(async (valid) => {
                    if (valid) {
                        const{
                            schoolYear:currentSchoolYear,
                            semester: currentSemester,
                            mailFrom,
                            mailDisplay,
                            dateBegin,
                            dateEnd,
                            reserved,
                            footer
                        } = this.sysModel;
                        const {success} = await this.saveSetting({
                            currentSchoolYear,
                            currentSemester,
                            mailDisplay,
                            mailFrom,
                            dateBegin,
                            dateEnd,
                            reserved,
                            footer
                        });
                        if(success){
                            this.$message({
                               type: 'success',
                               message: '異動成功'
                            });
                            form.clearValidate();
                        }

                    } else {
                        this.$message({
                            type: 'warning',
                            message: '您有欄位未填寫'
                        });
                    }
                });
            }
        },
        watch: {
            sys: {
                handler: function (sys) {
                    const {currentSchoolYear, currentSemester, mailDisplay, mailFrom, dateBegin, dateEnd, footer} = sys;
                    this.sysModel.mailDisplay = mailDisplay;
                    this.sysModel.semester = currentSemester;
                    this.sysModel.schoolYear = currentSchoolYear;
                    this.sysModel.mailFrom = mailFrom;
                    this.sysModel.dateBegin = dateBegin;
                    this.sysModel.dateEnd = dateEnd;
                    this.sysModel.footer = footer;
                },
                deep: true,

            }
        },
        created() {
            const {currentSchoolYear, currentSemester, mailDisplay, mailFrom, dateBegin, dateEnd, footer} = this.sys;
            this.sysModel.mailDisplay = mailDisplay;
            this.sysModel.semester = currentSemester;
            this.sysModel.schoolYear = currentSchoolYear;
            this.sysModel.mailFrom = mailFrom;
            this.sysModel.dateBegin = dateBegin;
            this.sysModel.dateEnd = dateEnd;
            this.sysModel.footer = footer;
        }
    }
</script>

<style scoped>

</style>